













import { Component, Vue } from 'vue-property-decorator'

const env: any = window

@Component
export default class ComponentWaterMark extends Vue {
  get text() {
    switch (env.ENV) {
      case 'development':
        return { title: 'DEV', description: 'Desenvolvimento' }

      case 'uat':
        return { title: 'UAT', description: 'Homologação' }

      case 'uatb':
        return { title: 'UAT-B', description: 'Homologação' }

      case 'arquitetura':
        return { title: 'ARQ', description: 'Arquitetura' }

      case 'pre-prod':
        return { title: 'PRE-PROD', description: 'Homologação' }

      default:
        return undefined
    }
  }

  get canShow() {
    if (window.location.hostname === 'localhost') {
      return false
    }

    switch (env.ENV) {
      case 'production':
        return false

      default:
        return true
    }
  }
}
